import React from 'react';
import { Shield, Lock, Clock } from 'lucide-react';
interface TrustStripProps {
  language: 'en' | 'es';
}
export function TrustStrip({
  language
}: TrustStripProps) {
  const content = {
    en: {
      badges: [{
        icon: Shield,
        label: 'No Credit Pull'
      }, {
        icon: Lock,
        label: 'Bank-Level Security'
      }, {
        icon: Clock,
        label: 'Funding in 24 Hours'
      }]
    },
    es: {
      badges: [{
        icon: Shield,
        label: 'Sin Revisión de Crédito'
      }, {
        icon: Lock,
        label: 'Seguridad de Nivel Bancario'
      }, {
        icon: Clock,
        label: 'Fondos en 24 Horas'
      }]
    }
  };
  const t = content[language];
  return <section className="w-full py-8 bg-gradient-to-r from-[#142B44] to-[#2D5D9F]" data-id="element-282">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-283">
        <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-8 lg:gap-12" data-id="element-284">
          {t.badges.map((badge, index) => <div key={index} className="flex items-center space-x-3 text-white" data-id="element-285">
              <div className="flex items-center justify-center w-10 h-10 bg-white/20 rounded-full" data-id="element-286">
                <badge.icon size={20} data-id="element-287" />
              </div>
              <span className="text-sm sm:text-base font-semibold whitespace-nowrap" data-id="element-288">
                {badge.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}